<template>
    <b-form-group
            :id="name"
            :label="label"
            :label-for="name">
        <b-form-checkbox
                :id="name"
                :name="name"
                @change="updateField($event)"
                v-model="checkedState"
                unchecked-value="false">
            {{label}}
        </b-form-checkbox>
    </b-form-group>
</template>

<script>
    export default {
        name: 'TextInput',
        props: ['placeholder', 'label', 'name', 'value'],
        data() {
            return {
                checkedState: this.value ? this.value : null
            };
        },
        methods: {
            updateField: function (currentState) {
                this.$emit('input', currentState);
            }
        },
        watch: {
            value: function (newValue) {
                this.checkedState = newValue;
            }
        },
    }

</script>